$( 'a[href^="#"]' ).not( '.js-scrol-to-top' ).on( 'click', function ( e ) {
	e.preventDefault();
	let target = this.hash;
	let $target = $( target );

	$( 'html, body' ).stop().animate( {
		scrollTop: $target.offset().top - 100,
	}, 900 );
} );
